import Button from 'devextreme-react/button';

export interface SiteSupportAdminRowActionsProps {
  onView: () => void;
  viewHint?: string;
  onEdit?: () => void;
  editHint?: string;
  onDelete?: () => void;
  deleteHint?: string;
}

/** Compact icon-only row actions for site-support admin grids. */
export function SiteSupportAdminRowActions({
  onView,
  viewHint = 'View details',
  onEdit,
  editHint = 'Edit',
  onDelete,
  deleteHint = 'Delete'
}: SiteSupportAdminRowActionsProps) {
  return (
    <div className="site-support-row-actions">
      <Button
        icon="eyeopen"
        stylingMode="text"
        hint={viewHint}
        elementAttr={{ 'aria-label': viewHint }}
        onClick={onView}
      />
      {onEdit ? (
        <Button
          icon="edit"
          stylingMode="text"
          hint={editHint}
          elementAttr={{ 'aria-label': editHint }}
          onClick={onEdit}
        />
      ) : null}
      {onDelete ? (
        <Button
          icon="trash"
          stylingMode="text"
          type="danger"
          hint={deleteHint}
          elementAttr={{ 'aria-label': deleteHint }}
          onClick={onDelete}
        />
      ) : null}
    </div>
  );
}

/** Width for the actions column given how many icon buttons are shown. */
export function siteSupportAdminActionsColumnWidth(actionCount: number): number {
  return Math.max(48, actionCount * 36 + 12);
}
